<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ item.Name }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, PRICES_STATUS_LIST)}">{{ item.Status | display_value(PRICES_STATUS_LIST) }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Global, PRICES_GLOBAL_LIST)}">{{ item.Global | display_value(PRICES_GLOBAL_LIST) }}</td>
                <td>{{ item.OrderType | display_value(ORDER_TYPE_LIST) }}</td>
                <td>{{ (item.ModifiedDate || item.CreatedDate) | display_date }}</td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="gotoDetail(item.ID)">fa-edit</v-icon>
                  <v-icon medium class="mr-2" @click="copyDetail(item.ID)">fa-copy</v-icon>
                  <v-icon medium @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "Bảng giá",
          value: "Name",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"],
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PRICES_STATUS_LIST,
          dataType: dataType["Enum"],
        },
        {
          text: "Phân loại",
          value: "Global",
          filterable: true,
          values: configs.PRICES_GLOBAL_LIST,
          dataType: dataType["Enum"],
        },
        {
          text: "Loại đơn",
          value: "OrderType",
          filterable: true,
          values: configs.ORDER_TYPE_LIST,
          dataType: dataType["Enum"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: dataType["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      PRICES_GLOBAL_LIST: configs.PRICES_GLOBAL_LIST,
      PRICES_STATUS_LIST: configs.PRICES_STATUS_LIST,
      ORDER_TYPE_LIST: configs.ORDER_TYPE_LIST,
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "prices_list",
      filterConditions: [],
      quickFilterConditions: [],
      requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  computed: mapState({
    items: (state) => state.prices.all.data,
    total_rows: (state) => state.prices.all.total,
    loading: (state) => state.prices.loading
  }),
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      this.$store.dispatch("prices/getList", param);
    },
    copyDetail: function (id) {
      this.$store.dispatch("prices/duplicateDetail", id);
    },
    gotoDetail: function (id) {
      this.$router.push({
        name: "PricesDetail",
        params: {
          Pid: id,
          title: `Chi tiết bảng giá (#${id})`,
        },
      });
    },
    deleteItem: function (id) {
      window.getApp.$emit("REQUEST_DELETE_DATA", id);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData(username = "") {
      this.$router.push({
        name: "PricesDetail",
        params: {
          Pid: "tao-moi",
          title: `Tạo mới bảng giá`,
        },
      });
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    }
  },
  mounted() {
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("prices/removeDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  },
};
</script>
